module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/2_8b5edeae756000b3854704a08108ab1f.png";